import { fetchApi } from '../../../lib/fetchApi';
import { ClaimAIDto, ClaimFormDto, ClaimFileDto, ClaimStatusList, ClaimServiceInidicatorBarChart, ClaimHistoricDto, ClaimStatusLineChartShow, ClaimParticipantData, ResponseClaimDto, ClaimTimelineKPIDto, ClaimIndicatorTimeTrackingDto, ClaimClosedFormDto, ClaimCancelFormDto, ClaimsByPersonPagination, ClaimPatientEmailForm } from '../types';

import { Pagination, PaginationFilterDto } from '../../../types/Pagination';
import { FilterDto } from '../../../types/FilterDto';

const BASE_URL = "/claim"

export const getClaim = async (claimId: number): Promise<ClaimFormDto> => {
    const response = await fetchApi.get(`${BASE_URL}/${claimId}`) as ClaimFormDto;
    return response;
}

export const getClaimDetail = async (idClaim: string): Promise<ClaimFormDto> => {
    const response = await fetchApi.get(`${BASE_URL}/detail/${idClaim}`) as ClaimFormDto;
    return response;
}

export const updateClaimDetail = async (claimId: string, body: ClaimFormDto): Promise<ResponseClaimDto> => {
    const response = await fetchApi.put(`${BASE_URL}/detail/${claimId}`, body) as ResponseClaimDto;
    return response;
}

export const getClaimDetailDocument = async (idClaim: string): Promise<ClaimFileDto[]> => {
    const response = await fetchApi.get(`${BASE_URL}/detail/document/${idClaim}`) as ClaimFileDto[];
    return response;
}

export const createClaim = async (claimForm: ClaimFormDto, file: File | null): Promise<ClaimFormDto> => {
    const formData = new FormData();
    if (file)    
        formData.append('file', file);
        
    formData.append('claimForm', JSON.stringify(claimForm));

    const response = await fetchApi.post<ClaimFormDto>(`${BASE_URL}/create`, formData);
    return response;
}

export const updateClaim = async (claimId: number, body: ClaimFormDto): Promise<ClaimFormDto> => {
    const response = await fetchApi.put(`${BASE_URL}/${claimId}`, body) as ClaimFormDto;
    return response;
}

export const cancelClaim = (id: number, claimCancelFormDto: ClaimCancelFormDto): Promise<void> =>
    fetchApi.put<void>(`${BASE_URL}/cancel/${id}`, claimCancelFormDto);

export const readDocument = async (file: File): Promise<ClaimFormDto> => {
    const formData = new FormData();    
    formData.append('file', file);

    const response = await fetchApi.post<ClaimFormDto>(`${BASE_URL}/read-document`, formData);

    return response;
};

export const processClaimAI = async (idClaim: number): Promise<ClaimAIDto> => {
    const response = await fetchApi.get(`${BASE_URL}/process-ai/${idClaim}`) as ClaimAIDto;
    return response;
}

export const saveClaimAI = async (body: ClaimAIDto): Promise<void> => {
    await fetchApi.post(`${BASE_URL}/save-resultAI`, body);
}

export const getHistoricClaims = async (body: PaginationFilterDto): Promise<Pagination<ClaimHistoricDto>> => 
    await fetchApi.post(`${BASE_URL}/history`, body) as Pagination<ClaimHistoricDto>;

export const getClaimStatus = async (filters: PaginationFilterDto): Promise<ClaimStatusList> => {
    const response = await fetchApi.post(`${BASE_URL}/dashboard/status`, filters) as ClaimStatusList;

    return response;
};

export const getClaimStatusLineChartData = async (filters: PaginationFilterDto): Promise<ClaimStatusLineChartShow[]> => {
    const response = await fetchApi.post(`${BASE_URL}/dashboard/status/line-chart`, filters) as ClaimStatusLineChartShow[];

    return response;
};

export const getClaimServiceIndicatorBarChartData = async (filters: PaginationFilterDto): Promise<ClaimServiceInidicatorBarChart[]> => {
    const response = await fetchApi.post(`${BASE_URL}/dashboard/service-indicator/bar-chart`, filters) as ClaimServiceInidicatorBarChart[];

    return response;
};

export const getParticipantDataFromSoap = async (cif: string): Promise<ClaimParticipantData> => {   
   return await fetchApi.get(`${BASE_URL}/patient-data/${cif}`);
};

export const getRecommendationByAI = async (claimForm: ClaimFormDto): Promise<string> => {   
   return await fetchApi.post(`${BASE_URL}/recommendation-ai`, claimForm);
};

export const getSuggestedMessageByAI = async (id: number): Promise<string> => {
   return await fetchApi.get(`${BASE_URL}/suggested-message-ai/${id}`);
};

export const getSentimentsTopicsAndAlertsByAI = async (id: number): Promise<ClaimAIDto> => {
    return await fetchApi.get(`${BASE_URL}/sentiment-alert-topics-ai/${id}`);
}

export const getClaimTimelineKPIs = async (filters: PaginationFilterDto): Promise<ClaimTimelineKPIDto> =>
    await fetchApi.post<ClaimTimelineKPIDto>(`${BASE_URL}/dashboard/timeline`, filters)

export const getClaimIndicatorsTimeTracking = async (filters: PaginationFilterDto): Promise<ClaimIndicatorTimeTrackingDto> =>
    await fetchApi.post<ClaimIndicatorTimeTrackingDto>(`${BASE_URL}/dashboard/indicator/time-tracking`, filters )

export const updateClaimClose = ( id: number, claimClosedFormDto: ClaimClosedFormDto): Promise<void> =>
    fetchApi.put<void>(`${BASE_URL}/close/${id}`, claimClosedFormDto);


export const getClaimRelatedPeopleAffectedPeople = async (filters: PaginationFilterDto): Promise<ClaimsByPersonPagination> =>
    await fetchApi.post<ClaimsByPersonPagination>(`${BASE_URL}/related-people/affected-people`, filters);

export const getClaimRelatedPeopleClaimantClaims = async (filters: PaginationFilterDto): Promise<ClaimsByPersonPagination> =>
    await fetchApi.post<ClaimsByPersonPagination>(`${BASE_URL}/related-people/claimant-claims`, filters);

export const getClaimFilters = async (): Promise<FilterDto[]> => {
    const response = await fetchApi.get<FilterDto[]>(`${BASE_URL}/filters`);
    return response;
};

export const sendEmailToPatient = async (formData: ClaimPatientEmailForm): Promise<ClaimFileDto> =>
    await fetchApi.post<ClaimFileDto>(`${BASE_URL}/email-patient`, formData);